<template>
  <div class="option" @mouseover="handleMouseOver" :style="handleBackground" :class="getOptionBg">
    <div class="option-label">
      <!-- <div class="option-promoted-icon">
        <img v-if="option.isPromoted" src="../../assets/svg/SVG/down_arrow.svg">
         <div v-if="option.isPromoted">*</div>
      </div> -->
      <div>{{ option.desc }}</div>
    </div>
    <div v-if="getOptionEditableState" class="option-funcs-holder">
      <div :id="'o-edit-btn' + option.id" class="option-button-edit" @click="handleEditClick($event, option)"><img class="option-edit-icon"
          src="../../assets/svg/SVG/edit.svg"></div>
      <div class="modal-prompt-delete-bg">
        <div v-show="getModalType === 'prompt-pipe' && getOption === currOption" style="border: 3px solid #f1f1f1;">
          <ModalPrompt></ModalPrompt>
        </div>
      </div>
      <div class="option-button-delete" @click="handleDeleteClick($event, option)"><img class="option-remove-icon"
          src="../../assets/svg/SVG/remove_btn.svg"></div>
    </div>
  </div>
</template>

<script>
import { useModalStore } from '@/store/ModalStore';
import { usePipeStore } from '@/store/PipeStore';
import ModalPrompt from '@/modal/ModalPrompt.vue';
import { useSegmentStore } from '@/store/SegmentStore';
import { useInputStore } from '@/store/InputStore';

export default {
  name: 'Option',
  props: [
    'option',
    'num'
  ],
  components: {
    ModalPrompt
  },
  data () {
    return {
      currOption: null
    };
  },
  computed: {
    getOption () {
      return this.$props.option;
    },
    getModalType () {
      return useModalStore().getModalType;
    },
    getOptionEditableState () {
      const visibility = usePipeStore().getPipeModalVisible;
      if (this.$props.option.isPromoted) {
        return this.$props.option.isUser && visibility;
      } else {
        return visibility;
      }
    },
    getOptionBg () {
      return parseInt(this.$props.num) % 2 === 1 ? '' : 'dark';
    },
    handleBackground () {
      if (this.$props.option.isHover === true) {
        return {
          'background-color': '#E7E7E7'
        };
      }
    },
  },
  methods: {
    handleEditClick (e, option) {
      e.stopImmediatePropagation();
      const pipeStore = usePipeStore();
      pipeStore.setPipeMode('edit');
      pipeStore.editedPipe = option;
      pipeStore.setAllowPipeEdit(true, 'edit');
    },
    handleModalCancel () {
      useModalStore().showModal('pipe');
      this.currOption = null;
    },
    handleDeletePipe () {
      // if deleted pipe is the one selected;
      useSegmentStore().getSegments('pipe').forEach((seg) => {
        if (seg.id === this.$props.option.id) {
          const defaultPipe = usePipeStore().getPipes[0];
          useSegmentStore().checkMatchingInletPipeTypes(seg, defaultPipe);
          useInputStore().sprinklerCalc();
        }
      });
      usePipeStore().deletePipe(this.$props.option.id);
    },
    handleDeleteClick (e, option) {
      this.currOption = option;
      e.stopImmediatePropagation();
      useModalStore().setModalObj({
        promptLabel: 'Remove '+ option.desc + ' pipe',
        promptDescription: 'Are you sure you want to remove this pipe?',
        buttonALabel: 'Delete',
        buttonAFunc: this.handleDeletePipe,
        buttonBLabel: 'Cancel',
        buttonBFunc: this.handleModalCancel
      });
      useModalStore().showModal('prompt-pipe');
    }
  }
};
</script>

<style scoped>
.option {
  user-select: none;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.option:hover {
  background-color: #E7E7E7;
}
.option-funcs-holder {
  display: flex;
  align-items: center;
}
.option-button-edit {
  cursor: pointer;
  padding-right: 3px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.option-button-delete {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.option-label {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  font-size: 80%;
  font-weight: bold;
  padding: 4px 4px 4px 10px;
}
.modal-prompt-delete-bg {
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 10px;
  z-index: 9999;
}
.option-remove-icon {
  width: 19px;
}
.option-remove-icon:hover {
  opacity: 5px;
}
.option-edit-icon {
  width: 16px;
}
.option-edit-icon:hover {
  opacity: 5px;
}
.option-promoted-icon {
  display: flex;
  align-items: center;
  width: 10px;
  padding-right: 5px;
}
</style>
